import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./Reports";

const Reports = lazy(() => import("./Reports"));

export default (props: Props) => (
  <Page>
    <Reports {...props} />
  </Page>
);
